import React from 'react';
import './StorefrontPoweredByFooter.css';

const NEAT_SCHEDULE_URL = 'https://neatschedule.com';

export default function StorefrontPoweredByFooter() {
  return (
    <footer className="storefront-powered-by-footer" role="contentinfo">
      <p className="storefront-powered-by-footer__text">
        Powered by{' '}
        <a
          href={NEAT_SCHEDULE_URL}
          className="storefront-powered-by-footer__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Neat Schedule
        </a>
      </p>
    </footer>
  );
}
